/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import classnames from 'classnames';
import resolveFrPhoto from '../utils/resolveFrPhoto.util';
import { PHONE_MEDIA_QUERY } from '../constants/media_query.constants';
import { jsxWith, jsxIf } from '../utils/jsx.util';
import RepPhoneNumber from './nm_rep_phone_number.component';
import NMEnsemble from './nm_ensemble.component';
import AgentForm from '../../../components/forms/AgentForm';

// TODO: this Component can be optimized in many places (hooks, refs, remove jsxIf,ErrorBoundaries,  etc)

/*
NMRepCard

Properties:
  rep - An instanceof of a FinancialRep to display information for
  target (optional) - The url to go to when 'Get Quote' is clicked
*/
export default class NMRepCard extends Component {
  constructor(props) {
    super(props);
    this.state = { isExpanded: false };
  }

  expand() {
    this.setState({ isExpanded: true });
  }

  collapse() {
    this.setState({ isExpanded: false });
  }

  toggle() {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  getStandardizedTitle(rep) {
    if (rep.type === 'MD') {
      return 'Managing Director';
    }

    return rep.title;
  }

  getFormattedAddress(rep) {
    const addressPieces = [];

    if (rep.street) addressPieces.push(rep.street);
    if (rep.building) addressPieces.push(rep.building);

    addressPieces.push(`\n${rep.city}, ${rep.state}`);

    if (rep.zipLastFour) {
      addressPieces.push(`${rep.zip}-${rep.zipLastFour}`);
    } else {
      addressPieces.push(rep.zip);
    }

    return addressPieces.join(' ');
  }

  render() {
    return jsxWith(this.props.rep, rep => (
      <div className='nmx-search-rep-card vcard'>
        <div className={classnames('nmx-row', { 'is-expanded': this.state.isExpanded })}>
          <div className='nmx-col nmx-col-xsmall-12 nmx-col-small-6 nmx-col-medium-7 nmx-col-nested'>
            <div className='nmx-row'>
              <div className='nmx-col nmx-col-xsmall-12 nmx-col-small-6 nmx-col-medium-4 nmx-col-nested-child'>
                <img src={resolveFrPhoto(rep)} alt={rep.fullName} className='fr-photo photo' />
              </div>
              <div className='nmx-col nmx-col-xsmall-12 nmx-col-small-6 nmx-col-medium-8 nmx-col-nested-child'>
                {/* TODO: parse out name for microformats "given-name", "family-name", etc */}
                <h3 className='fr-name n'><span className="fn">{rep.fullName}</span></h3>
                <span className='fr-title'>{this.getStandardizedTitle(rep)}</span>
                <NMEnsemble agentnumber={rep.id}></NMEnsemble>
                {(() => {
                  if (rep.designations) {
                    return (
                      <ul className='fr-professional-designations'>
                        {rep.designations.map((designation, index) => (
                          <li key={index} className='fr-professional-designation'>
                            <span>{designation}</span>
                          </li>
                        ))}
                      </ul>
                    );
                  }
                  return false;
                })()}{' '}
                <a href='https://brokercheck.finra.org/' target='_blank' rel='nofollow noopener noreferrer'>FINRA BrokerCheck</a>
              </div>
            </div>
          </div>
          <div className='nmx-col nmx-col-xsmall-12 nmx-col-small-6 nmx-col-medium-5 nmx-col-nested-child'>
            {/* TODO: formatted address needs some love, needs microformats */}
            <address className="nmx-p fr-address adr location value">{this.getFormattedAddress(rep)}</address>
            {rep.selectedPhone1
              ? <RepPhoneNumber phoneNumber={rep.selectedPhone1.Number}/>
              : false}
            {rep.selectedPhone2
              ? <RepPhoneNumber phoneNumber={rep.selectedPhone2.Number}/>
              : false}
            {rep.selectedPhone3
              ? <RepPhoneNumber phoneNumber={rep.selectedPhone3.Number}/>
              : false}
            <ul className='fr-contact-links reduced'>
              {jsxIf(rep.slug, () => (
                <li className='fr-contact-link-container'>
                  <a href={`/financial/advisor/${rep.slug}/`} aria-label={`Link to ${rep.fullName} profile page`} className='fr-contact-link'>view my profile page</a>
                </li>
              ))}
            </ul>
            <button className='nmx-button nmx-button--secondary fr-contact-cta' onClick={this.toggle.bind(this)}>Contact</button>
          </div>
        </div>
        {jsxIf(this.state.isExpanded, () => (
          <div className='nmx-row fr-contact'>
            <div className='nmx-col nmx-col-xsmall-12 nmx-col-medium-5 fr-contact-more-info nmx-col-nested-child'>
              {jsxIf(rep.briefBio, () => (
                <h5>About My Practice</h5>
              ))}
              {jsxIf(rep.briefBio, () => (
                <p>
                  {rep.briefBio}
                </p>
              ))}
              <h5 className='block'>Location</h5>
              <a href={`https://maps.google.com/maps?q=loc:${rep.latitude},${rep.longitude}`} target='_blank' rel='nofollow noopener noreferrer'>
                <picture>
                  <source srcSet={`https://maps.googleapis.com/maps/api/staticmap?center=${rep.latitude},${rep.longitude}&size=250x414&markers=${rep.latitude},${rep.longitude}&maptype=roadmap&zoom=13&key=<%=googlePlacesApiKey%>`} media={PHONE_MEDIA_QUERY} />
                  <img src={`https://maps.googleapis.com/maps/api/staticmap?center=${rep.latitude},${rep.longitude}&size=534x282&markers=${rep.latitude},${rep.longitude}&maptype=roadmap&zoom=13&key=<%=googlePlacesApiKey%>`} alt='Google Map'/>
                </picture>
              </a>
            </div>
            <div className='nmx-col nmx-col-xsmall-12 nmx-col-medium-7 fr-contact-service'>
              <AgentForm
                agentnumber={rep.id}
                floodlightsendto={this.props.floodlightsendto}
                isPcg={false}
                useRecaptcha={false}
                formLocation="search"
                campaign={this.props.campaign}
                source={this.props.source}
                topic={this.props.topic}
              />
            </div>
          </div>
        ))}
      </div>
    ));
  }
}
